import lazyLoading from './lazyLoading'

export default {
  name: 'padronAICM',
  meta: {
    expanded: false,
    title: 'Padrón',
    iconClass: 'vuestic-icon vuestic-icon-user'
  },
  children: [
    {
      path: '/config-drivers',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'menu.drivers'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/DriversList'),
          meta: {
            title: 'menu.drivers'
          }
        },
        {
          path: 'new', // Default route
          component: lazyLoading('config/DriverNew'),
          meta: {
            title: 'Sub Zonas'
          }
        },
        {
          path: ':driverId',
          component: lazyLoading('config/DriverView'),
          props: true,
          meta: {
            title: 'menu.drivers'
          }
        }
      ]
    },
    {
      path: '/config-holders',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Permisionarios'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/HolderList'),
          meta: {
            title: 'Permisionarios'
          }
        },
        {
          path: 'new',
          component: lazyLoading('config/HolderView'),
          props: true,
          meta: {
            title: 'Permisionarios'
          }
        },
        {
          path: ':holderId',
          component: lazyLoading('config/HolderView'),
          props: true,
          meta: {
            title: 'Permisionarios'
          }
        }
      ]
    },
    {
      path: '/config-cars',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Vehículos'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/CarsList'),
          meta: {
            title: 'Vehículos'
          }
        },
        {
          path: ':carId',
          component: lazyLoading('config/CarView'),
          props: true,
          meta: {
            title: 'Vehículo'
          }
        }
      ]
    },
    {
      path: '/expired-documents',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Documentos Vencidos'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/ExpiredDocumentsList'),
          meta: {
            title: 'Documentos Vencidos'
          }
        }
      ]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/padronAICM.js